import Highcharts from 'highcharts/highstock';
require('highcharts/modules/sunburst')(Highcharts);
require('highcharts/modules/no-data-to-display')(Highcharts);
require('highcharts/modules/pattern-fill')(Highcharts);
// Loaded through require, not import, so it evaluates after the modules above rather than being
// hoisted ahead of them.
require('./highcharts_custom');

// Highcharts registers `$.fn.highcharts` on window.jQuery whenever it loads, and the last copy to
// load on the page wins that global. Our pages embed bundles from other apps (see
// shared/_react_component_prereq) that ship their own Highcharts and load after us, so a chart
// created or looked up through `$.fn.highcharts` could resolve against an instance that is not
// ours -- the plugin closes over that copy's own `charts` registry.
//
// This module owns our copy: it registers the modules and customizations every chart expects, and
// the helpers below use the `Highcharts` import instead of the jQuery plugin

// Accepts an element, a jQuery object, or a CSS selector. `Highcharts.chart` would also take a
// bare element id, but `getHighchart` can only ever match on an element, so we resolve here to
// keep both helpers accepting the same things.
const toElement = (target) => {
  if (typeof target === 'string') {
    return document.getElementById(target) || document.querySelector(target) || undefined;
  }

  return target && target.jquery ? target[0] : target;
};

export function createHighchart(target, options, callback) {
  const element = toElement(target);

  if (!element) {
    return undefined;
  }

  return Highcharts.chart(element, options, callback);
}

export function getHighchart(target) {
  const element = toElement(target);

  if (!element) {
    return undefined;
  }

  // We match on `renderTo` rather than the element's `data-highcharts-chart` index, which is only
  // meaningful to the copy that wrote it and would index into a foreign `charts` registry.
  // `charts` is sparse -- destroy() blanks the slot -- so destroyed charts are simply absent.
  return Highcharts.charts.find((chart) => chart && chart.renderTo === element);
}
